'use strict';
MainTopController.$inject = ['$scope', '$mdSidenav', '$mdDialog', '$rootScope', '$timeout'];
DECISYON.ng.register.module('ngPopover');
DECISYON.ng.register.controller('mainTopCtrl', ($scope, $mdSidenav, ngPopover, $rootScope, $timeout) => new MainTopController($scope, $mdSidenav, ngPopover, $rootScope, $timeout));
